/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScoringHealthStatus } from './ScoringHealthStatus';
import {
    ScoringHealthStatusFromJSON,
    ScoringHealthStatusFromJSONTyped,
    ScoringHealthStatusToJSON,
    ScoringHealthStatusToJSONTyped,
} from './ScoringHealthStatus';

/**
 * 
 * @export
 * @interface ScoringHealthModeResponse
 */
export interface ScoringHealthModeResponse {
    /**
     * 
     * @type {ScoringHealthStatus}
     * @memberof ScoringHealthModeResponse
     */
    status: ScoringHealthStatus;
    /**
     * The mode the player is in, in the game's own words ("Trios", "Team Deathmatch"). Present when GREEN or RED.
     * @type {string}
     * @memberof ScoringHealthModeResponse
     */
    label?: string;
    /**
     * Player-facing reason, present when RED.
     * @type {string}
     * @memberof ScoringHealthModeResponse
     */
    reason?: string;
}



/**
 * Check if a given object implements the ScoringHealthModeResponse interface.
 */
export function instanceOfScoringHealthModeResponse(value: object): value is ScoringHealthModeResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function ScoringHealthModeResponseFromJSON(json: any): ScoringHealthModeResponse {
    return ScoringHealthModeResponseFromJSONTyped(json, false);
}

export function ScoringHealthModeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScoringHealthModeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': ScoringHealthStatusFromJSON(json['status']),
        'label': json['label'] == null ? undefined : json['label'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function ScoringHealthModeResponseToJSON(json: any): ScoringHealthModeResponse {
    return ScoringHealthModeResponseToJSONTyped(json, false);
}

export function ScoringHealthModeResponseToJSONTyped(value?: ScoringHealthModeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': ScoringHealthStatusToJSON(value['status']),
        'label': value['label'],
        'reason': value['reason'],
    };
}

